import {createSlice} from '@reduxjs/toolkit';
import {SensorsState} from './types';
import {loadWorkspaceOccupancy} from './actions';

const initialState: SensorsState = {
  workspaceOccupancyByBuildingId: {},
};

const slice = createSlice({
  name: 'sensors',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadWorkspaceOccupancy.pending, (state, action) => {
        const buildingId = action.meta.arg;
        state.workspaceOccupancyByBuildingId[buildingId] = {
          status: 'loading',
          error: null,
          states: [],
          timestamp: new Date().toISOString(),
        };
      })

      .addCase(loadWorkspaceOccupancy.fulfilled, (state, action) => {
        const buildingId = action.meta.arg;
        state.workspaceOccupancyByBuildingId[buildingId] = {
          ...state.workspaceOccupancyByBuildingId[buildingId]!,
          status: 'loaded',
          error: null,
          states: action.payload,
        };
      })

      .addCase(loadWorkspaceOccupancy.rejected, (state, action) => {
        const buildingId = action.meta.arg;
        state.workspaceOccupancyByBuildingId[buildingId] = {
          ...state.workspaceOccupancyByBuildingId[buildingId]!,
          status: 'failed',
          error: action.error.message ?? 'Failed to load workspace occupancy',
          states: [],
        };
      });
  },
});

export const {reducer: sensorsReducer} = slice;
